module.exports = "/images/vendor/flag-icon-css/flags/1x1/it.svg?22b99ae704f3de63285bc9b9411c5031";